module.exports = __webpack_public_path__ + "img/logo.ea01c3df.png";